/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FilterBrightnessSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FilterBrightnessSmall',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('rect', {"width":"6","height":"6","rx":"3","transform":"translate(3 3)","fill":"currentColor"}),createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M7 0v2.126a4.007 4.007 0 00-2 0V0h2zM3.968 2.554l-.796-.797-.708-.707L1.05 2.464l.707.708.797.796a4.02 4.02 0 011.414-1.414zM2.126 5H0v2h2.126a4.007 4.007 0 010-2zm.428 3.032l-.797.796-.707.708 1.414 1.414.708-.707.796-.797a4.02 4.02 0 01-1.414-1.414zM5 9.874V12h2V9.874a4.007 4.007 0 01-2 0zm3.032-.428l.796.797.708.707 1.414-1.414-.707-.708-.797-.796a4.02 4.02 0 01-1.414 1.414zM9.874 7H12V5H9.874a4.007 4.007 0 010 2zm-.428-3.032l.797-.796.707-.708L9.536 1.05l-.708.707-.796.797a4.02 4.02 0 011.414 1.414z","fill":"currentColor"}))
}
